import { useMediaQuery } from 'react-responsive';

const useResponsive = () => {
  // const { height, width } = document.body.getBoundingClientRect()
  // const isMobile = width < 500;

  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const isMobileBig = useMediaQuery({ query: "(max-width: 760px)" });
  const isTab = useMediaQuery({ query: "(max-width: 850px)" });
  const isTabLand = useMediaQuery({ query: "(max-width: 1300px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1600px)" });
  const isDesktop = useMediaQuery({ query: "(max-width: 1799px)" });
  const isBigDesktop = useMediaQuery({ query: "(min-width: 1800px)" });

  return {
    isMobile,
    isMobileBig,
    isTab,
    isTabLand,
    isLaptop,
    isDesktop,
    isBigDesktop
  };
};
 
export default useResponsive;
